// import React from "react";

// const ProgressTabList = () => {
//   return <div>ProgressTabList</div>;
// };

// export default ProgressTabList;

import React from "react";
import { ProgressTab, ProgressTabAdv } from "../../../../../components";

const ProgressTabList = () => {
  const tabCount = 5;

  const TabsMenu = Array.from({ length: tabCount }, (_, i) => ({
    title: `Tab-${i + 1}`,
    page: `page-${i + 1}`,
  }));

  const tabsAdv = [
    {
      title: "Fill Details",
      status: "Completed",
      icon: "group_add",
      color: "success",
    },
    {
      title: "Add Checklist",
      icon: "checklist_rtl",
      color: "primary",
      status: "In Progress",
    },
    {
      title: "Initiate Onboarding",
      icon: "airplane_ticket",
    },
  ];

  return (
    <div className="w-full flex flex-1 flex-col overflow-auto">
      <div className="mt-5">
        <h6 className="mb-5">Progress Tab Adv</h6>
        <ProgressTabAdv tabs={tabsAdv} activeTab={2} />
      </div>

      {TabsMenu.map((_, tabIndex) =>
        TabsMenu.map((_, slideIndex) =>
          slideIndex >= tabIndex ? (
            <div key={`tab-${tabIndex}-slide-${slideIndex}`}>
              <ProgressTab
                tabs={TabsMenu}
                initialActiveTab={tabIndex}
                initialActiveSlide={slideIndex}
              />
              <p className="text-center text-xs">
                Tab {tabIndex + 1} - Slide {slideIndex + 1}
              </p>
            </div>
          ) : null
        )
      )}
    </div>
  );
};

export default ProgressTabList;
